import { useEffect } from 'react';

import { isRunningInNativeApp, native } from '@muzly/shared';

/**
 * Sync native-shell state into web app state. Subscribes to the
 * notifications the native shell pushes (app lifecycle).
 * No-op in a plain browser.
 */
export const useNativeSync = (): void => {
  useEffect(() => {
    if (!isRunningInNativeApp()) {
      return;
    }

    // Placeholder for future use (e.g. refetch on foreground).
    const offAppState = native.on('appStateChanged', () => {
      // no-op
    });

    return () => {
      offAppState();
    };
  }, []);
};
